import React, { useState, useEffect } from 'react';
import { SketchPicker } from 'react-color';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

const Swatch = styled('div')`
  width: 40px;
  height: 40px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.grey['300']};
  cursor: pointer;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
`;

const SwatchSmall = styled('div')`
  width: 20px;
  height: 20px;
  border-radius: ${({ rounded }) => (rounded ? '50%' : '4px')};
  background-color: ${(props) => props.color};
  border: 1px solid;
  border-color: ${({ theme }) => theme.palette.grey['300']};
  cursor: pointer;
`;

const StyledRoot = styled(FormControl)`
  position: relative;
`;

export default ({
  value,
  onChange,
  size,
  label,
  hint,
  hasError,
  helpText,
  rounded,
  hideValue = false,
  margin = 'none',
}) => {
  const [showPicker, setShowPicker] = useState(false);
  const [color, setColor] = useState(value);
  const togglePicker = () => setShowPicker(!showPicker);
  const hidePicker = () => setShowPicker(false);

  useEffect(() => {
    setColor(value);
  }, [value]);

  const handleChange = ({ hex }) => {
    setColor(hex);
    onChange && onChange(hex);
  };

  const popover = {
    position: 'absolute',
    zIndex: '2',
  };
  const cover = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  };

  return (
    <StyledRoot error={hasError} margin={margin}>
      {label && (
        <FormLabel sx={{ mb: 1 }} component="legend">
          {label}
        </FormLabel>
      )}
      <Stack direction="row" spacing={1}>
        {size === 'small' ? (
          <>
            {!hideValue && (
              <Typography textTransform="uppercase">{color}</Typography>
            )}
            <SwatchSmall
              rounded={rounded}
              color={color}
              onClick={togglePicker}
            />
          </>
        ) : (
          <Swatch color={color} onClick={togglePicker} />
        )}
      </Stack>
      {showPicker ? (
        <div style={popover}>
          <div style={cover} onClick={hidePicker} />
          <SketchPicker
            disableAlpha={true}
            onChange={handleChange}
            color={color}
          />
        </div>
      ) : null}
      {hasError && (
        <FormHelperText error sx={{ m: 0 }}>
          {helpText}
        </FormHelperText>
      )}
    </StyledRoot>
  );
};
